import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useSelector } from 'react-redux';

const steps = [
  { id: 1, label: 'Checkout' },
  { id: 2, label: 'Down payment' },
  { id: 3, label: 'Direct debit setup' },
  { id: 4, label: '' },
];

export default function Stepper({ currentStep, totalSteps }) {
  const downPaymentSuccess = useSelector(
    (state) => state.fullPayment.downPaymentSuccess
  );

  return (
    <div className="w-full md:max-w-3xl mx-auto bg-white rounded-xl border shadow px-2 py-4 md:p-6 pb-12 my-4">
      <h2 className="font-semibold text-lg mb-2">Order Placing</h2>

      <div className="flex flex-col items-center w-full">
        {/* Circles + connectors row */}
        <div className="flex items-center justify-between w-full">
          {steps.map((step, index) => {
            // Default styles
            let circleColor = 'bg-gray-200';
            let circleSize = 'w-3 h-3';

            // Step is completed
            if (step.id < currentStep) {
              circleColor = 'bg-[#3DB54A]';
            }

            // Active step
            if (step.id === currentStep) {
              circleColor = 'bg-[#3DB54A]';
            }

            // Next step after current
            if (step.id === currentStep + 1) {
              circleColor = 'bg-[#FFDE11]';
            }

            // Special handling for down payment success
            if (downPaymentSuccess && step.id === 3) {
              circleColor = 'bg-[#FFDE11]';
            }

            return (
              <div key={step.id} className="flex items-center w-full relative">
                {/* Step Circle OR Cart Icon */}
                {step.id === steps.length ? (
                  totalSteps ? (
                    <img
                      src="/images/checkout-cart.svg"
                      alt="Cart Icon"
                      className="w-6 h-6"
                    />
                  ) : (
                    <ShoppingCart size={24} className="text-gray-400" />
                  )
                ) : (
                  <div
                    className={`flex items-center justify-center rounded-full z-10 transition-all duration-200 ${circleColor} ${circleSize}`}
                  ></div>
                )}

                {/* Connector Line */}
                {index < steps.length - 1 && (
                  <div
                    className={`flex-1 w-[50px] md:w-[110px] h-1 mx-1 rounded ${
                      // Connector turns green if this step is completed
                      step.id < currentStep ||
                      step.id === currentStep ||
                      (downPaymentSuccess && step.id === 2) ||
                      totalSteps
                        ? 'bg-[#3DB54A]'
                        : 'bg-gray-200'
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>

        {/* Labels row */}
        <div className="flex justify-between w-full mt-">
          {steps.map((step) => (
            <div key={step.id} className="flex-1  md:w-[110px] text-start pl-5">
              {step.label && (
                <p className="text-[9px] md:text-xs font-duplet md:text-nowrap">
                  {step.label}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
